import { merge } from 'lodash';
import { LmiReviewMachine } from '~/machines/lmi-review';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { LmiReview, LmiReviewProps } from './component/lmi-review.component';

type LmiReviewContainerProps = {
  micro: ContextSendMatch<LmiReviewMachine>;
  overrideCopy?: LmiReviewProps['overrideCopy'];
  overrideProps?: DeepPartial<LmiReviewProps>;
};

export const LmiReviewContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: LmiReviewContainerProps) => {
  const props: LmiReviewProps = {
    context,
    pending: !matches('lmiReview.idle'),
    skip: data => send({ type: 'SKIP_LMI_REVIEW', data }),
    loading:
      matches('lmiReview.fetching') ||
      matches('lmiReview.fetchingUtilityAccount') ||
      matches('lmiReview.saveProofDocs'),
    next: data => send({ type: 'UPLOAD_PROOFS_AND_GENERATE_ENVELOPE', data }),
    overrideCopy,
    error: '',
  };

  return <LmiReview {...merge(props, overrideProps)} />;
};
